import styled from 'styled-components'

const Input = styled.input.attrs({
  type: 'checkbox',
})`
  & + label {
    min-height: ${props => (props.size === 'lg' ? '28px' : '16px')};
  }
  &:checked,
  &:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    padding-left: ${props =>
      props.label && props.size === 'lg' ? '38px' : props.label ? '26px' : props.size === 'lg' ? '28px' : '16px'};
    cursor: pointer;
    display: inline-grid;
    align-items: center;
    user-select: none;
    // color: inherit;
  }
  &:checked + label:before,
  &:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: ${props => (props.size === 'lg' ? '28px' : '16px')};
    height: ${props => (props.size === 'lg' ? '28px' : '16px')};
    background-color: ${props => props.theme.palette.background.paper};
    border: ${props => props.theme.globals.borderDark};
    border-width: 1px;
    border-radius: ${props => props.theme.globals.borderRadiusSmall}px;
    transition: ${props => props.theme.mixins.transition(['all'])};
  }
  &:not(:checked) + label:hover:before,
  &:checked + label:before {
    border-color: ${props => props.theme.palette.primary.main};
    border-width: ${props => (props.size === 'lg' ? '3px' : '2px')};
  }
  &:checked + label:before {
    background-color: ${props => props.theme.palette.background.paper};
  }
  &:checked + label:after,
  &:not(:checked) + label:after {
    content: '';
    color: ${props => props.theme.palette.text.primary};
    width: ${props => (props.size === 'lg' ? '18px' : '8px')};
    height: ${props => (props.size === 'lg' ? '10px' : '5px')};
    position: absolute;
    top: ${props => (props.size === 'lg' ? '-5px' : '-2px')};
    left: ${props => (props.size === 'lg' ? '5px' : '4px')};
    bottom: 0;
    margin: auto;
    border-bottom: ${props => (props.size === 'lg' ? '3px' : '2px')} solid ${props => props.theme.palette.primary.main};
    border-left: ${props => (props.size === 'lg' ? '3px' : '2px')} solid ${props => props.theme.palette.primary.main};
    transform: rotate(-45deg);
    transform-origin: center;
    transition: ${props => props.theme.mixins.transition(['all'])};
  }
  &[disabled] + label:before {
    border: ${props => props.theme.globals.borderDisabled} !important;
  }
  &[disabled] + label:after {
    background: ${props => props.theme.palette.status.disabled} !important;
  }
  &:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0), rotate(-45deg);
  }
  &:checked + label:after {
    opacity: 1;
    transform: scale(1), rotate(-45deg);
  }
`

export default Input
